import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const extendedChoiceMenuDefaultVariants = {}
const extendedChoiceMenuCompoundVariants = []

const extendedChoiceMenuSlotNames = [
  [
    "surface",
    "ExtendedChoiceMenu__surface"
  ],
  [
    "list",
    "ExtendedChoiceMenu__list"
  ],
  [
    "option",
    "ExtendedChoiceMenu__option"
  ],
  [
    "checkboxSlot",
    "ExtendedChoiceMenu__checkboxSlot"
  ],
  [
    "iconSlot",
    "ExtendedChoiceMenu__iconSlot"
  ],
  [
    "icon",
    "ExtendedChoiceMenu__icon"
  ],
  [
    "body",
    "ExtendedChoiceMenu__body"
  ],
  [
    "label",
    "ExtendedChoiceMenu__label"
  ],
  [
    "description",
    "ExtendedChoiceMenu__description"
  ],
  [
    "trailing",
    "ExtendedChoiceMenu__trailing"
  ],
  [
    "dividerWrap",
    "ExtendedChoiceMenu__dividerWrap"
  ],
  [
    "createRow",
    "ExtendedChoiceMenu__createRow"
  ]
]
const extendedChoiceMenuSlotFns = /* @__PURE__ */ extendedChoiceMenuSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, extendedChoiceMenuDefaultVariants, getSlotCompoundVariant(extendedChoiceMenuCompoundVariants, slotName))])

const extendedChoiceMenuFn = memo((props = {}) => {
  return Object.fromEntries(extendedChoiceMenuSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const extendedChoiceMenuVariantKeys = [
  "descriptive"
]
const getVariantProps = (variants) => ({ ...extendedChoiceMenuDefaultVariants, ...compact(variants) })

export const extendedChoiceMenu = /* @__PURE__ */ Object.assign(extendedChoiceMenuFn, {
  __recipe__: false,
  __name__: 'extendedChoiceMenu',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: extendedChoiceMenuVariantKeys,
  variantMap: {
  "descriptive": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, extendedChoiceMenuVariantKeys)
  },
  getVariantProps
})